export default __webpack_public_path__ + "static/media/logoen-dxpanel.67d218aa.png";